/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Device = /** @class */ (function () {
    /**
     * Constructs a new instance of the Device class
     */
    function Device() {
        // don't attempt to fingerprint browsers
        this.id = "browser";
        // Device type is a dimension in our data platform
        // Setting it to 'Browser' allows to separate client and server dependencies/exceptions
        this.deviceClass = "Browser";
    }
    return Device;
}());
export { Device };
//# sourceMappingURL=Device.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-properties-js/dist-esm/Context/Device.js
// module id = 318
// module chunks = 37